import { OptiversalESIUI } from "./OptiversalESIUI";
import { StandardProps } from "../componentMap";

export function OptiversalESI({ product }: Pick<StandardProps, "product">) {
  const breadcrumb = product.browsePageHierarchy[1]?.name
    .replace(/\s/g, "-")
    .toLowerCase();
  const productTitle = product.title;
  const linkingQuery = encodeURIComponent(productTitle.trim());

  const src = `/esi/optiversal?linkingQuery=${linkingQuery}&breadcrumb=${breadcrumb}`;

  return <OptiversalESIUI src={src} />;
}
